import React, { ErrorInfo } from 'react'
import { Provider } from 'react-redux'
import store from '@/store'
import Intl from '@/locale'

export default class AppComponent extends React.Component {

    render() {
        return <Provider store={store}>
            <Intl>
                {this.props.children}
            </Intl>
        </Provider>
    }
}

window.document.body.onload = () => {
    const sc = window.document.createElement('script')
    sc.src='https://www.googletagmanager.com/gtag/js?id=G-0DY7HYP36P'
    window.document.body.appendChild(sc);
    (window as any).dataLayer = (window as any).dataLayer || [];
    function gtag(...args: any){ (window as any).dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', 'G-0DY7HYP36P');
}